// extracted by mini-css-extract-plugin
export default {"coachCell":"Qu1Xo1SAvBtZk4Yc2dsN"};